module.exports = __webpack_public_path__ + "static/media/hand-point-down.b93d75fb.svg";